isSinglePageCheckoutActive